import apiService from "../apiService"

const usersApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchUsers: builder.query({
      query: (query) => ({ url: "admin/user", params: query }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateUser: builder.mutation({
      query: (user) => ({
        url: "admin/user",
        method: "PUT",
        body: { user },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateUser: builder.mutation({
      query: (user) => ({
        url: "admin/user",
        method: "PUT",
        body: { user },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    updateUserPatch: builder.mutation({
      query: (patch) => ({
        url: "admin/user",
        method: "PATCH",
        body: { patch },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addUser: builder.mutation({
      query: (user) => ({
        url: "admin/user",
        method: "POST",
        body: user,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    deleteUser: builder.mutation({
      query: (user) => ({
        url: "admin/user",
        method: "DELETE",
        body: user,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchLocations: builder.query({
      query: () => ({ url: "location" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default usersApiSlice

export const {
  useLazyFetchUsersQuery,
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useUpdateUserPatchMutation,
} = usersApiSlice

export const {} = usersApiSlice
